import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/File.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'home',
		component: Home,
	},
	{
		path: '/lightDoc',
		component: () => import('../views/LightDocView.vue'),
	},
	{
		path: '/editHistory',
		name: 'history',
		component: () => import('@/pages/H5/Cloud/views/EditHistory.vue'),
	},
	{
		path: '/export',
		name: 'export',
		component: () => import('@/pages/H5/Cloud/views/Export.vue'),
	},
]

const router = new VueRouter({
	routes,
	mode: 'history',
	base: 'cloud',
})

export default router
